import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CContainer, CRow, CCol, CCard, CCardBody, CSpinner } from '@coreui/react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import logo_stream from 'assets/brand/logo_stream.png';
import { apiClient } from 'services/Api';
import { triggerAlert } from 'components/globals/AlertNotification';

const SatisfactionSurveyCompleted = () => {
    const { uuid } = useParams();
    const [companyName, setCompanyName] = useState('');
    const [clientScore, setClientScore] = useState(null);
    const [averageScore, setAverageScore] = useState(null);
    const [averageScores, setAverageScores] = useState(null);
    const [clientScores, setClientScores] = useState([]);
    const [loading, setLoading] = useState(true);

    const evaluationLabels = [
        'Informação', 'Dúvidas', 'Tempo\nResposta', 'Resolução', 'Integração',
        'Cump.\nCondições', 'Compt. e\nResp.', 'Global', 'Fornecedor\nIdeal',
        'Qualidade\nPreço', 'Ausência\nProblemas', 'Gerir\nProblemas',
        'Próx.\nProjeto', 'Recomendar'
    ];

    const fetchChartData = async () => {
        try {
            const response = await apiClient.get(`/satisfaction-surveys/${uuid}/results/`, { skipAuth: true });
            const data = response.data;

            setCompanyName(data.client_name);
            setClientScore(data.client_score);
            setAverageScore(data.average_score);
            setAverageScores(data.average_scores);
            setClientScores(data.client_scores);
        } catch (error) {
            triggerAlert('Erro ao carregar os dados do questionário.', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchChartData();
    }, [uuid]);

    const chartOptions = {
        chart: {
            type: 'column',
            height: 400,
        },
        title: { text: null },
        xAxis: {
            categories: evaluationLabels,
            labels: { style: { fontSize: '11px' } },
        },
        yAxis: {
            min: 0,
            max: 6,
            tickInterval: 1,
            title: { text: 'Pontuação' },
        },
        tooltip: { shared: true },
        series: [
            {
                name: 'Global',
                type: 'line',
                data: averageScores,
                color: 'rgb(38, 185, 154)',
                marker: { enabled: true },
            },
            {
                name: companyName,
                type: 'column',
                data: clientScores,
                color: 'rgba(52, 73, 94, 0.8)',
            },
        ],
        legend: {
            align: 'center',
            verticalAlign: 'bottom',
        },
    };

    if (loading) {
        return (
            <CContainer className="text-center py-5">
                <CSpinner color="primary" size="lg" />
            </CContainer>
        );
    }

    return (
        <CContainer>
            <CRow className="justify-content-center my-4">
                <CCol md={6} className="text-center">
                    <img src={logo_stream} alt="Logo" style={{ maxWidth: '300px' }} />
                </CCol>
            </CRow>

            <CRow className="justify-content-center">
                <CCol md={8}>
                    <CCard>
                        <CCardBody className="text-center">
                            <h4>O processo de preenchimento do questionário encontra-se concluído.</h4>
                            <h5>
                                Avaliou a STREAM com: <strong>{clientScore?.toFixed(2)}</strong>
                            </h5>
                            <h5>
                                Pontuação média da STREAM: <strong>{averageScore?.toFixed(2)}</strong>
                            </h5>
                            <h5>Obrigado pela sua colaboração!</h5>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>

            <CRow className="mt-4">
                <CCol>
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default SatisfactionSurveyCompleted;
